module.exports = __webpack_public_path__ + "cc0018dd59ba4cd153c2a6978a4a0f04.svg";